import React from 'react';
import './suggestions.scss';

const Suggestions = (props) => {
  const { keyword = '', dataSource = [], onClick } = props;

  const escapedSeparator = keyword.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  const pattern = new RegExp(`(${escapedSeparator})`);

  const renderItems = dataSource.map((item) => {
    const renderLine = keyword
      ? (item.label || '')
          .split(pattern)
          .map((word) => {
            return {
              text: word,
              type: word === keyword ? 'keyword' : 'text',
            };
          })
          .filter((i) => !!i.text)
      : [
          {
            text: item.label,
            type: 'text',
          },
        ];
    return {
      ...item,
      renderLine,
      type: item.type || 'setInputText',
    };
  });

  if (!renderItems.length) return null;

  return (
    <div className="chati-ui-suggestions">
      {renderItems.map((item) => (
        <div
          className="item"
          onClick={() => {
            onClick(item);
          }}
        >
          {item.renderLine.map((word) => (
            <span className={word.type}>{word.text}</span>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Suggestions;
